import React from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  onSelectExisting: () => void;
  onSelectCreate: () => void;
}

const AddTeamsModal: React.FC<Props> = ({
  open,
  onClose,
  onSelectExisting,
  onSelectCreate,
}) => {
  if (!open) return null;

  return (
    <div className="atm-overlay" onClick={onClose}>
      <div className="atm-modal atm-modal--options" onClick={(e) => e.stopPropagation()}>
        <div className="atm-header">
          <h3 className="atm-title">Add Teams</h3>
          <button type="button" className="atm-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="atm-add-teams-form">
          <p className="atm-add-teams-label">How would you like to add teams?</p>
          <div className="atm-add-teams-actions">
            <button type="button" className="atm-add-teams-btn atm-add-teams-btn--secondary" onClick={onSelectExisting}>
              Existing teams — add from this tournament
            </button>
            <button type="button" className="atm-add-teams-btn atm-add-teams-btn--primary" onClick={onSelectCreate}>
              Create new team
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTeamsModal;
